import { render, staticRenderFns } from "./ChallengeEntries.vue?vue&type=template&id=71c6f568"
import script from "./ChallengeEntries.vue?vue&type=script&lang=js"
export * from "./ChallengeEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports